import { render, staticRenderFns } from "./FolderSelector.vue?vue&type=template&id=2a16b01d&scoped=true&lang=pug"
import script from "./FolderSelector.vue?vue&type=script&lang=ts"
export * from "./FolderSelector.vue?vue&type=script&lang=ts"
import style0 from "./FolderSelector.vue?vue&type=style&index=0&id=2a16b01d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a16b01d",
  null
  
)

export default component.exports